export const GicsSectorL4 = {
  SpecializedFinance: 'Specialized Finance',
  ElectronicManufacturingServices: 'Electronic Manufacturing Services',
  PaperProducts: 'Paper Products',
  SemiconductorMaterialsEquipment: 'Semiconductor Materials & Equipment',
  IndustrialConglomerates: 'Industrial Conglomerates',
  ElectricUtilities: 'Electric Utilities',
  HealthCareFacilities: 'Health Care Facilities',
  ElectronicComponents: 'Electronic Components',
  EnvironmentalFacilitiesServices: 'Environmental & Facilities Services',
  DiversifiedREITs: 'Diversified REITs',
  DiversifiedCapitalMarkets: 'Diversified Capital Markets',
  OtherSpecializedREITs: 'Other Specialized REITs',
  CommunicationsEquipment: 'Communications Equipment',
  ConsumerStaplesMerchandiseRetail: 'Consumer Staples Merchandise Retail',
  LifeSciencesToolsServices: 'Life Sciences Tools & Services',
  OilGasDrilling: 'Oil & Gas Drilling',
  DataCenterREITs: 'Data Center REITs',
  AgriculturalFarmMachinery: 'Agricultural & Farm Machinery',
  TiresRubber: 'Tires & Rubber',
  BroadlineRetail: 'Broadline Retail',
  EducationServices: 'Education Services',
  ElectronicEquipmentInstruments: 'Electronic Equipment & Instruments',
  HealthCareREITs: 'Health Care REITs',
  ResearchConsultingServices: 'Research & Consulting Services',
  ApplicationSoftware: 'Application Software',
  ITConsultingOtherServices: 'IT Consulting & Other Services',
  AssetManagementCustodyBanks: 'Asset Management & Custody Banks',
  RealEstateOperatingCompanies: 'Real Estate Operating Companies',
  HousewaresSpecialties: 'Housewares & Specialties',
  CasinosGaming: 'Casinos & Gaming',
  DiversifiedSupportServices: 'Diversified Support Services',
  HealthCareDistributors: 'Health Care Distributors',
  Brewers: 'Brewers',
  Broadcasting: 'Broadcasting',
  AirFreightLogistics: 'Air Freight & Logistics',
  OfficeServicesSupplies: 'Office Services & Supplies',
  HouseholdProducts: 'Household Products',
  ForestProducts: 'Forest Products',
  HealthCareTechnology: 'Health Care Technology',
  AutomobileManufacturers: 'Automobile Manufacturers',
  DistillersVintners: 'Distillers & Vintners',
  SpecializedConsumerServices: 'Specialized Consumer Services',
  CommodityChemicals: 'Commodity Chemicals',
  DiversifiedBanks: 'Diversified Banks',
  Distributors: 'Distributors',
  WirelessTelecommunicationServices: 'Wireless Telecommunication Services',
  ConstructionMaterials: 'Construction Materials',
  RealEstateDevelopment: 'Real Estate Development',
  AirportServices: 'Airport Services',
  Footwear: 'Footwear',
  Silver: 'Silver',
  MultiLineInsurance: 'Multi-line Insurance',
  GasUtilities: 'Gas Utilities',
  SpecialtyChemicals: 'Specialty Chemicals',
  Publishing: 'Publishing',
  LeisureProducts: 'Leisure Products',
  LeisureFacilities: 'Leisure Facilities',
  ManagedHealthCare: 'Managed Health Care',
  IntegratedTelecommunicationServices: 'Integrated Telecommunication Services',
  MarinePortsServices: 'Marine Ports & Services',
  ConstructionMachineryHeavyTransportationEquipment:
    'Construction Machinery & Heavy Transportation Equipment',
  PackagedFoodsMeats: 'Packaged Foods & Meats',
  RegionalBanks: 'Regional Banks',
  AutomotiveRetail: 'Automotive Retail',
  RealEstateServices: 'Real Estate Services',
  ConsumerFinance: 'Consumer Finance',
  CoalConsumableFuels: 'Coal & Consumable Fuels',
  HumanResourceEmploymentServices: 'Human Resource & Employment Services',
  CommercialPrinting: 'Commercial Printing',
  Pharmaceuticals: 'Pharmaceuticals',
  HighwaysRails: 'Highways & Railtracks',
  MoviesEntertainment: 'Movies & Entertainment',
  Reinsurance: 'Reinsurance',
  DiversifiedRealEstateActivities: 'Diversified Real Estate Activities',
  PassengerAirlines: 'Passenger Airlines',
  OilGasStorageTransportation: 'Oil & Gas Storage & Transportation',
  FertilizersAgriculturalChemicals: 'Fertilizers & Agricultural Chemicals',
  FinancialExchangesData: 'Financial Exchanges & Data',
  PropertyCasualtyInsurance: 'Property & Casualty Insurance',
  SelfStorageREITs: 'Self-Storage REITs',
  MetalGlassPlasticContainers: 'Metal, Glass & Plastic Containers',
  RenewableElectricity: 'Renewable Electricity',
  ComputerElectronicsRetail: 'Computer & Electronics Retail',
  TransactionPaymentProcessingServices:
    'Transaction & Payment Processing Services',
  HealthCareSupplies: 'Health Care Supplies',
  Steel: 'Steel',
  HealthCareEquipment: 'Health Care Equipment',
  HealthCareServices: 'Health Care Services',
  OilGasExplorationProduction: 'Oil & Gas Exploration & Production',
  TimberREITs: 'Timber REITs',
  SecurityAlarmServices: 'Security & Alarm Services',
  OtherSpecialtyRetail: 'Other Specialty Retail',
  MarineTransportation: 'Marine Transportation',
  AutomotivePartsEquipment: 'Automotive Parts & Equipment',
  ApparelRetail: 'Apparel Retail',
  Restaurants: 'Restaurants',
  FoodDistributors: 'Food Distributors',
  HomeFurnishings: 'Home Furnishings',
  ConstructionEngineering: 'Construction & Engineering',
  TechnologyHardwareStoragePeripherals:
    'Technology Hardware, Storage & Peripherals',
  IndependentPowerProducersEnergyTraders:
    'Independent Power Producers & Energy Traders',
  IndustrialREITs: 'Industrial REITs',
  LifeHealthInsurance: 'Life & Health Insurance',
  IndustrialMachinerySuppliesComponents:
    'Industrial Machinery & Supplies & Components',
  MotorcycleManufacturers: 'Motorcycle Manufacturers',
  InsuranceBrokers: 'Insurance Brokers',
  Homebuilding: 'Homebuilding',
  HeavyElectricalEquipment: 'Heavy Electrical Equipment',
  DiversifiedFinancialServices: 'Diversified Financial Services',
  AlternativeCarriers: 'Alternative Carriers',
  Biotechnology: 'Biotechnology',
  TechnologyDistributors: 'Technology Distributors',
  PaperPlasticPackagingProductsMaterials:
    'Paper & Plastic Packaging Products & Materials',
  TelecomTowerREITs: 'Telecom Tower REITs',
  RailTransportation: 'Rail Transportation',
  HotelResortREITs: 'Hotel & Resort REITs',
  MortgageREITs: 'Mortgage REITs',
  MultiUtilities: 'Multi-Utilities',
  BuildingProducts: 'Building Products',
  OilGasRefiningMarketing: 'Oil & Gas Refining & Marketing',
  HomeImprovementRetail: 'Home Improvement Retail',
  PersonalCareProducts: 'Personal Care Products',
  DataProcessingOutsourcedServices: 'Data Processing & Outsourced Services',
  Gold: 'Gold',
  Copper: 'Copper',
  TradingCompaniesDistributors: 'Trading Companies & Distributors',
  RetailREITs: 'Retail REITs',
  Tobacco: 'Tobacco',
  CargoGroundTransportation: 'Cargo Ground Transportation',
  DiversifiedMetalsMining: 'Diversified Metals & Mining',
  SystemsSoftware: 'Systems Software',
  Advertising: 'Advertising',
  CommercialResidentialMortgageFinance:
    'Commercial & Residential Mortgage Finance',
  MultiFamilyResidentialREITs: 'Multi-Family Residential REITs',
  ConsumerElectronics: 'Consumer Electronics',
  OilGasEquipmentServices: 'Oil & Gas Equipment & Services',
  OfficeREITs: 'Office REITs',
  AerospaceDefense: 'Aerospace & Defense',
  FoodRetail: 'Food Retail',
  InvestmentBankingBrokerage: 'Investment Banking & Brokerage',
  PassengerGroundTransportation: 'Passenger Ground Transportation',
  IntegratedOilGas: 'Integrated Oil & Gas',
  DrugRetail: 'Drug Retail',
  DiversifiedChemicals: 'Diversified Chemicals',
  MultiSectorHoldings: 'Multi-Sector Holdings',
  HotelsResortsCruiseLines: 'Hotels, Resorts & Cruise Lines',
  HouseholdAppliances: 'Household Appliances',
  ApparelAccessoriesLuxuryGoods: 'Apparel, Accessories & Luxury Goods',
  Aluminum: 'Aluminum',
  IndustrialGases: 'Industrial Gases',
  CableSatellite: 'Cable & Satellite',
  InternetServicesInfrastructure: 'Internet Services & Infrastructure',
  PreciousMetalsMinerals: 'Precious Metals & Minerals',
  ElectricalComponentsEquipment: 'Electrical Components & Equipment',
  WaterUtilities: 'Water Utilities',
  HomefurnishingRetail: 'Homefurnishing Retail',
  InteractiveMediaServices: 'Interactive Media & Services',
  Semiconductors: 'Semiconductors',
  AgriculturalProductsServices: 'Agricultural Products & Services',
  SoftDrinksNonAlcoholicBeverages: 'Soft Drinks & Non-alcoholic Beverages',
  InteractiveHomeEntertainment: 'Interactive Home Entertainment',
} as const

export type GicsSectorL4 = (typeof GicsSectorL4)[keyof typeof GicsSectorL4]
